// extracted by mini-css-extract-plugin
export default {"root":"Panel4_root_Hi2OB"};